module.exports = __webpack_public_path__ + "static/sagedoublebcardi-7edfa6b082b75e5044f4b967ac0e40d7.jpeg";